import React from 'react'

export default function Reminders () {
  return (
    <div>
      Reminders
    </div>
  )
}
